module.exports = __webpack_public_path__ + "static/media/logo_small.0637aa56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_small.png
// module id = 587
// module chunks = 0